import {
  QA_GET_OFFERS_LISTING,
  QA_GET_OFFERS_LISTING_SUCCESS,
  QA_GET_OFFERS_LISTING_FAILED,
  QA_OFFER_EDIT,
  QA_OFFER_EDIT_SUCCESS,
  QA_OFFER_EDIT_FAIL,
  QA_OFFER_UPDATE,
  QA_OFFER_UPDATE_SUCCESS,
  QA_OFFER_UPDATE_FAIL,
} from "./actionTypes"

export const qaOffersListing = history => {
  return {
    type: QA_GET_OFFERS_LISTING,
  }
}

export const qaOffersListingSuccess = offer => {
  return {
    type: QA_GET_OFFERS_LISTING_SUCCESS,
    payload: offer,
  }
}

export const qaOffersListingFail = error => {
  return {
    type: QA_GET_OFFERS_LISTING_FAILED,
    payload: error,
  }
}

export const qaOfferEdit = offer_id => {
  return {
    type: QA_OFFER_EDIT,
    payload: { id: offer_id },
  }
}

export const qaEditOfferSuccess = offer => {
  return {
    type: QA_OFFER_EDIT_SUCCESS,
    payload: offer,
  }
}

export const qaEditOfferFail = error => {
  return {
    type: QA_OFFER_EDIT_FAIL,
    payload: error,
  }
}

export const qaUpdateOffer = (offer, history) => {
  return {
    type: QA_OFFER_UPDATE,
    payload: { offer, history },
  }
}

export const qaUpdateOfferSuccess = offer => {
  return {
    type: QA_OFFER_UPDATE_SUCCESS,
    payload: offer,
  }
}

export const qaUpdateOfferFail = error => {
  return {
    type: QA_OFFER_UPDATE_FAIL,
    payload: error,
  }
}
